import React from 'react';
import { Invest } from '../components/invest/Invest';
export default function InvestPage() { return <Invest />; }
